var map = {
	"./Carte-JJ.png": "c80d",
	"./Carte-Virtuelle-Ecobank-Apaym.png": "0d7b",
	"./Carte-apaym-pro.png": "4c83",
	"./Carte-classique.png": "9a94",
	"./Carte-phoenix.png": "54b7",
	"./Carte-platinum-blanche-ccs.png": "c689",
	"./Carte-platinum-blanche.png": "a016",
	"./Carte-platinum-noire-ccs.png": "2269",
	"./Carte-platinum-noire.png": "b8ad",
	"./Carte-virtuelle-ecobank.png": "2cba",
	"./Carte-virtuelle-uba.png": "278f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1235";